import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPostAutoDebitAccountBody } from 'src/app/feature/BNPL/shared/models/automaticDebits.model';
import {
  IAccountType,
  IDebitAccounts,
} from 'src/app/feature/BNPL/shared/models/debitAccounts.model';
import { BnplService } from 'src/app/feature/BNPL/shared/services/bnpl.service';

@Component({
  selector: 'app-add-debit',
  templateUrl: './add-debit.component.html',
  styleUrls: ['./add-debit.component.css'],
})
export class AddDebitComponent {
  @Output() setAutoDebitAccount =
    new EventEmitter<IPostAutoDebitAccountBody | null>();
  @Output() setAutoDebitAccountImage = new EventEmitter<string>();
  @Output() changeStep = new EventEmitter<number>();
  @Output() changeAutomaticDebit = new EventEmitter<boolean>();
  @Input() entitys: IDebitAccounts[] | null = null;

  entitySelected: IDebitAccounts | null = null;
  typeSelected: IAccountType | null = null;
  numberSelect: string = '';
  addDebitCheck: boolean = false;
  typeList: IAccountType[] = [
    { name: 'Corriente', value: '1' },
    { name: 'Ahorros', value: '2' },
  ];

  constructor(private bnplService: BnplService) {}

  handleStepsCredit(step: number) {
    this.changeStep.emit(step);
  }

  handleSelectedDebit() {
    if (this.entitySelected && this.typeSelected && this.numberSelect) {
      const transformDebit: IPostAutoDebitAccountBody = {
        personId: this.bnplService.stepsInformation.firstStep.numeroDocumento,
        bankName: this.entitySelected.Nombre,
        bankCode: this.entitySelected.Codigo,
        accountType: this.typeSelected.value,
        currency: 'PESOS',
        accountNumber: this.numberSelect,
      };
      document.body.classList.remove('no-scroll');
      this.setAutoDebitAccount.emit(transformDebit);
      this.setAutoDebitAccountImage.emit(this.entitySelected.url);
      this.changeAutomaticDebit.emit(false);
    }
  }
}
